import api from "api"

export const logOut = () => {
  api.logout()
}
